import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LoadingSpinner } from '.';
import s from './LoadingIndicator.css';

const propTypes = {
    className: PropTypes.string,
    show: PropTypes.bool,
    float: PropTypes.oneOf(['none', 'left', 'right']),
    label: PropTypes.string,
    labelOnRight: PropTypes.bool,
    isInline: PropTypes.bool,
    spinnerColor: PropTypes.string,
    spinnerSize: PropTypes.number,
};

export class LoadingIndicator extends React.Component {
    static defaultProps = {
        className: undefined,
        show: true,
        float: 'none',
        label: '',
        labelOnRight: false,
        isInline: false,
        spinnerColor: undefined,
        spinnerSize: 24,
    };

    render() {
        return (
            <div
                className={classNames(
                    s.indicator,
                    {
                        [s.inline]: this.props.isInline,
                        [s.left]: this.props.float === 'left',
                        [s.right]: this.props.float === 'right',
                        [s.show]: this.props.show,
                    },
                    this.props.className
                )}
            >
                {this.props.labelOnRight === false && this.renderLabel()}
                <LoadingSpinner size={this.props.spinnerSize} color={this.props.spinnerColor || undefined} />
                {this.props.labelOnRight === true && this.renderLabel()}
            </div>
        );
    }

    renderLabel() {
        return <p>{this.props.label}</p>;
    }
}

LoadingIndicator.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/loaders/LoadingIndicator.jsx